/* eslint-disable */
import React from 'react';
import { Divider, Tab, Tabs } from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router-dom';

function DiceTabs() {
  const location = useLocation();
  const tabs = [
    {
      label: 'Search',
      to: '/dice/search',
    },
    // {
    //   label: 'Jobs', 
    //   to: '/dice/jobs',
    // },
    {
      label: 'Dashboard',
      to: '/dice/dashboard',
    },
    {
      label: 'History',
      to: '/dice/history',
    },
  ];

  return (
    <div className="w-full bg-white">
      <Tabs 
        value={tabs.findIndex(tab => location.pathname.startsWith(tab.to))}
        className="pl-8"
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.to}
            label={tab.label}
            component={Link}
            to={tab.to}
            sx={{
              padding: '1px 12px',
              minWidth: '8rem',
            }}
          />
        ))}
      </Tabs>
      <Divider className="pl-8" />
      <Outlet />
    </div>
  );
}

export default DiceTabs;
